import format from '../../node_modules/date-fns/esm/format/index.js';

//
var script = {
  name: 'DateRenderer',
  props: {
    date: {
      type: [String, Number],
      default: undefined
    }
  },
  computed: {
    formattedDate() {
      return this.date && format(new Date(this.date), 'dd MMMM yyyy');
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/DateRenderer.vue_rollup-plugin-vue=script.js